import { c as _c } from "react/compiler-runtime";
import { IcoInfo16, IcoSpeedometer16 } from '@onefootprint/icons';
import type { DocumentViewerScore, PiiJsonValue } from '@onefootprint/request-types/dashboard';
import { Tooltip } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import useSession from '@/hooks/use-session';
type ScoresCardProps = {
  scores: DocumentViewerScore[];
};
type FormatScoreLabels = {
  booleanYes: string;
  booleanNo: string;
};
const formatScore = (score: PiiJsonValue, labels: FormatScoreLabels): string => {
  if (typeof score === 'number') {
    // Format as percentage or fraction
    if (score <= 1) {
      return `${Math.round(score * 100)}/100`;
    }
    return `${Math.round(score)}/100`;
  }
  if (typeof score === 'string') {
    return score;
  }
  if (typeof score === 'boolean') {
    return score ? labels.booleanYes : labels.booleanNo;
  }
  return JSON.stringify(score);
};
const ScoresCard = t0 => {
  const $ = _c(22);
  const {
    scores
  } = t0;
  const {
    t
  } = useTranslation("document-viewer");
  const {
    data: session
  } = useSession();
  const isFirmEmployee = !!session.user?.isFirmEmployee;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== isFirmEmployee || $[1] !== scores || $[2] !== t) {
    t5 = Symbol.for("react.early_return_sentinel");
    bb0: {
      let t6;
      if ($[8] !== isFirmEmployee) {
        t6 = score => !score.isFirmEmployeeOnly || isFirmEmployee;
        $[8] = isFirmEmployee;
        $[9] = t6;
      } else {
        t6 = $[9];
      }
      const visibleScores = scores.filter(t6);
      if (visibleScores.length === 0) {
        t5 = null;
        break bb0;
      }
      const formatLabels = {
        booleanYes: t(_temp),
        booleanNo: t(_temp2)
      };
      t3 = "bg-primary border border-tertiary rounded-md p-3 flex flex-col gap-4";
      let t7;
      if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = <IcoSpeedometer16 />;
        $[10] = t7;
      } else {
        t7 = $[10];
      }
      let t8;
      if ($[11] !== t) {
        t8 = t(_temp3);
        $[11] = t;
        $[12] = t8;
      } else {
        t8 = $[12];
      }
      if ($[13] !== t8) {
        t4 = <div className="flex items-center gap-1">{t7}<span className="text-label-2 text-primary">{t8}</span></div>;
        $[13] = t8;
        $[14] = t4;
      } else {
        t4 = $[14];
      }
      t1 = "grid grid-cols-2 gap-3 md:flex md:flex-col md:gap-4";
      t2 = visibleScores.map(score_0 => <div key={score_0.displayName} className="flex flex-col gap-1 justify-between"><div className="flex items-center gap-1 text-caption-2 text-tertiary">{score_0.displayName}{isFirmEmployee && score_0.isFirmEmployeeOnly && <Tooltip content={t(_temp4)}><span className="flex"><IcoInfo16 /></span></Tooltip>}</div><div className="text-caption-2" style={{
          color: score_0.color
        }}>{formatScore(score_0.score, formatLabels)}</div></div>);
    }
    $[0] = isFirmEmployee;
    $[1] = scores;
    $[2] = t;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
  }
  if (t5 !== Symbol.for("react.early_return_sentinel")) {
    return t5;
  }
  let t6;
  if ($[15] !== t1 || $[16] !== t2) {
    t6 = <div className={t1}>{t2}</div>;
    $[15] = t1;
    $[16] = t2;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t3 || $[19] !== t4 || $[20] !== t6) {
    t7 = <div className={t3}>{t4}{t6}</div>;
    $[18] = t3;
    $[19] = t4;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
};
export default ScoresCard;
function _temp($) {
  return $.sidebar.booleanYes;
}
function _temp2($_0) {
  return $_0.sidebar.booleanNo;
}
function _temp3($_1) {
  return $_1.sidebar.scores;
}
function _temp4($_2) {
  return $_2.sidebar.hiddenFromTenants;
}